const STOP_WORDS = new Set([
  'the', 'a', 'an', 'is', 'it', 'to', 'and', 'of', 'in', 'that', 'for',
  'on', 'with', 'as', 'at', 'by', 'from', 'or', 'but', 'not', 'be',
  'are', 'was', 'were', 'been', 'being', 'have', 'has', 'had', 'do',
  'does', 'did', 'will', 'would', 'could', 'should', 'may', 'might',
  'shall', 'can', 'this', 'its', 'you', 'your',
]);

const DIGIT_TO_WORD: Record<string, string> = {
  '0': 'zero',
  '1': 'one',
  '2': 'two',
  '3': 'three',
  '4': 'four',
  '5': 'five',
  '6': 'six',
  '7': 'seven',
  '8': 'eight',
  '9': 'nine',
  '10': 'ten',
};

function normalize(text: string): string {
  // Convert digits to words before normalizing
  let normalized = text.toLowerCase();
  // Replace multi-digit numbers first (10), then single digits
  normalized = normalized.replace(/\b(\d+)\b/g, (match) => DIGIT_TO_WORD[match] || match);
  return normalized
    .replace(/[^a-z\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function extractKeywords(text: string): string[] {
  return normalize(text)
    .split(' ')
    .filter((word) => word.length > 0 && !STOP_WORDS.has(word));
}

/**
 * Checks if a word exists in text as a whole word (not as a substring).
 */
function containsWord(text: string, word: string): boolean {
  const regex = new RegExp(`\\b${word}\\b`);
  return regex.test(text);
}

/**
 * Matches a speech transcript against a rule sentence.
 * Extracts keywords (filtering stop words) and checks >= 70% keyword match.
 */
export function matchesSpeech(transcript: string, expected: string): boolean {
  const expectedKeywords = extractKeywords(expected);
  if (expectedKeywords.length === 0) return true;

  const transcriptNormalized = normalize(transcript);

  let matchCount = 0;
  for (const keyword of expectedKeywords) {
    if (containsWord(transcriptNormalized, keyword)) {
      matchCount++;
    }
  }

  return matchCount / expectedKeywords.length >= 0.7;
}

/**
 * Matches a speech transcript against a fact equation like "three plus one equals four".
 * All tokens are critical — checks >= 80% token match.
 */
export function matchesFactSpeech(transcript: string, expected: string): boolean {
  const expectedTokens = normalize(expected).split(' ').filter((w) => w.length > 0);
  if (expectedTokens.length === 0) return true;

  const transcriptNormalized = normalize(transcript);

  let matchCount = 0;
  for (const token of expectedTokens) {
    if (containsWord(transcriptNormalized, token)) {
      matchCount++;
    }
  }

  return matchCount / expectedTokens.length >= 0.8;
}
